import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Message, Segment } from 'semantic-ui-react';
import { useApi } from '../../../contexts/ApiContext';
import { Reseller } from './reseller.type';
import { UploadImage } from '../../../types/fileTypes';
import { HandleInputChange } from '../../../types/inputs';
import { Images } from '../../Input/Images';
import axios from 'axios';
import { AxiosResponseError } from '../../../types/axios';

interface FormProps extends Omit<Reseller, 'id' | 'image'> {
  image: UploadImage | null;
}

type FormErrors = {
  [key in keyof FormProps]?: string
}

export const NewReseller: React.FC = () => {
  const history = useHistory();
  const [formData, setFormData] = useState<FormProps>({} as FormProps);
  const [errors, setErrors] = useState<FormErrors>({});
  const [error, setError] = useState<AxiosResponseError>();
  const [loading, setLoading] = useState(false);
  const { callApi } = useApi();

  const handleChange: HandleInputChange
    = (e, { name, value }) => setFormData({ ...formData, [name]: value } as Pick<FormProps, keyof FormProps>)

  const handleFileChange = (name: string, file: UploadImage) => {
    setFormData({ ...formData, [name]: file });
  }

  const handleFileRemove = (name: string) => {
    setFormData({ ...formData, [name]: null });
  }

  const formValidate = (): boolean => {
    let isValid = true;
    const errors: FormErrors = {};

    if (!formData.name) {
      errors.name = "Name is required"
      isValid = false;
    }

    if (!formData.image) {
      errors.image = "Image is required";
      isValid = false;
    }

    if (!formData.url) {
      errors.url = "URL is required";
      isValid = false;
    }

    if (!formData.type) {
      errors.type = " Please select official store";
      isValid = false;
    }

    setErrors({ ...errors });

    return isValid;
  }

  const onSubmit = async () => {
    if (formValidate()) {
      try {
        setLoading(true);
        let imageUrl = '';

        if (formData.image) {
          const { data: signedUrl } = await callApi.get<string>(`/s3/uploadUrl?folder=reseller&fileExtension=${formData.image.type.split('/')[1]}`);
          await axios.put(signedUrl, formData.image.data, {
            headers: {
              'Content-Type': formData.image.type
            }
          });

          imageUrl = signedUrl.split('?')[0];
        }

        await callApi.post('/reseller', { ...formData, image: imageUrl });
        history.push('/reseller');
      }
      catch (e) {
        setLoading(false);
        setError(e);
      }
    }
  }

  const renderError = () => {
    return (
      <>
        <Message hidden={!Object.keys(errors).length} negative>
          <p>{errors[Object.keys(errors)[0] as keyof FormErrors]}</p>
        </Message>
        <Message hidden={!error} negative>
          <p>{error?.response?.data || 'Some thing went wrong'}</p>
        </Message>
      </>
    )
  }

  return (
    <div>
      <h1>Create New Reseller</h1>
      <Segment>
        {renderError()}
        <Form>
          <Form.Input name='name' label="Name" width="8" onChange={handleChange}></Form.Input>
          <Form.Input name='url' label="URL" width="8" onChange={handleChange}></Form.Input>
          <Form.Field>
            <label>Image</label>
            <Images name='image' onSuccess={handleFileChange} onRemove={handleFileRemove} />
          </Form.Field>
          <Form.Field>

            <label>Official Store</label>
            <Form.Dropdown name='type' options={[{
              key: 1,
              value: 'official',
              text: "Yes"
            }, {
              key: 2,
              value: 'retail',
              text: 'No'
            }]} width="8"
              onChange={(e, selection) => selection.value && setFormData({ ...formData, type: selection.value as string })}
              value={formData.type}
              placeholder="Official Store"
              selection
            >
            </Form.Dropdown>
          </Form.Field>
          <Form.Button color='vk' onClick={onSubmit} loading={loading}>Submit</Form.Button>
        </Form>
      </Segment>
    </div >
  );
}